import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UtilsService, ClientService, ModalService } from '@app/services';
import { I18nPipe } from '@app/shared/pipes/i18n.pipe';

@Component({
  selector: 'app-sms-widget',
  templateUrl: 'sms-widget.component.html',
  styleUrls: ['sms-widget.component.css']
})

/**
 * SMS Widget Class
 */
export class SmsWidgetComponent implements OnInit {
  @Input()
  page: any;
  bg: 'string';
  client: any;

  constructor(
    protected clientService: ClientService,
    protected router: Router,
    protected utils: UtilsService,
    protected i18n: I18nPipe,
    protected modalService: ModalService
  ) { }

  ngOnInit() {
    this.clientService.getClient().subscribe(client => {
      this.client = client;
    });
  }

  /**
	 * open
	 * routes to the sms component
	 * @param page the page with the sms content information
	 * @returns void
	 */
  open() {
    this.modalService.openWidget(this.page);
  }

  /**
	 * setBGStyle
	 * this function is called by the dom elems to check style information
	 * @return {Object} style class
	 */
  setBGStyle() {
    if (this.client && this.client.colors) {
      const styles = {
        'background-color': this.utils.hexToRgb(this.client.colors.lightBG, this.page.opacity),
      };
      return styles;
    }
    return {};
  }

  getBackgroundPosition() {
    if (this.page && this.page['centerImage']) {
      return 'center';
    }
    return 'left top';
  }

  /**
	 * setFontStyle
	 * this function is called by the dom elems to check style information
	 * @return {Object} style class
	 */
  setFontStyle() {
    if (this.client && this.client.colors) {
      const styles = {
        'color': this.client.colors.main,
      };
      return styles;
    }
    return {};
  }

  getBackground(image: any): string {
    const imageUrl = this.i18n.transform(image, false);
    if (imageUrl && imageUrl !== '') {
      return 'url(' + imageUrl + ')';
    }
    return '';
  }

}
